import { useCallback, useRef } from 'react'
import Editor, { Monaco } from '@monaco-editor/react'
import {
  registerStructurizrLanguage,
  STRUCTURIZR_LANGUAGE_ID,
} from '../lib/structurizr-language'

interface DslEditorProps {
  value: string
  onChange: (value: string) => void
  readOnly?: boolean
}

export default function DslEditor({ value, onChange, readOnly = false }: DslEditorProps) {
  const monacoRef = useRef<Monaco | null>(null)

  const handleEditorChange = useCallback(
    (value: string | undefined) => {
      if (value !== undefined) {
        onChange(value)
      }
    },
    [onChange]
  )

  const handleEditorWillMount = useCallback((monaco: Monaco) => {
    monacoRef.current = monaco
    // Register Structurizr DSL language before editor mounts
    registerStructurizrLanguage(monaco)
  }, [])

  return (
    <div className="h-full border border-gray-300 rounded-lg overflow-hidden">
      <Editor
        height="100%"
        defaultLanguage={STRUCTURIZR_LANGUAGE_ID}
        value={value}
        onChange={handleEditorChange}
        beforeMount={handleEditorWillMount}
        options={{
          minimap: { enabled: false },
          fontSize: 14,
          lineNumbers: 'on',
          readOnly,
          wordWrap: 'on',
          scrollBeyondLastLine: false,
          automaticLayout: true,
          tabSize: 4,
          renderWhitespace: 'selection',
        }}
        theme="structurizr-light"
      />
    </div>
  )
}
